module.exports = __webpack_public_path__ + "img/blue_085.f1632c4f.png";